import { __read } from "tslib";
import { DisplayObject } from '@antv/g';
/** get attr value in transform */
export function getTransform(el, attr) {
    var _a;
    var node = el instanceof DisplayObject ? el : el.node();
    var transform = node.computedStyleMap().get('transform');
    if (!transform || transform.value === 'unset')
        return undefined;
    return (_a = transform === null || transform === void 0 ? void 0 : transform.find(function (_a) {
        var t = _a.t;
        return t === attr;
    })) === null || _a === void 0 ? void 0 : _a.d.map(function (_a) {
        var value = _a.value;
        return value;
    });
}
export function hasSetRotate(el) {
    return !!getTransform(el, 'rotate');
}
export function getTranslate(el, x, y) {
    var node = el instanceof DisplayObject ? el : el.node();
    var _a = node.getBBox(), width = _a.width, height = _a.height;
    var _b = __read([x, y].map(function (v, i) {
        var _a;
        return v.includes('%')
            ? (parseFloat(((_a = v.match(/[+-]?([0-9]*[.])?[0-9]+/)) === null || _a === void 0 ? void 0 : _a[0]) || '0') / 100) * (i === 0 ? width : height)
            : v;
    }), 2), tx = _b[0], ty = _b[1];
    return [tx, ty];
}
export function translate(el, x, y) {
    var node = el instanceof DisplayObject ? el : el.node();
    var _a = __read(getTranslate(el, x, y), 2), tx = _a[0], ty = _a[1];
    node.attr('transform', "translate(".concat(tx, ", ").concat(ty, ")"));
}
/**
 * transform that support translate percent value
 */
export function percentTransform(el, val) {
    if (!val)
        return;
    try {
        var node_1 = el instanceof DisplayObject ? el : el.node();
        var reg = /translate\(([+-]*[\d]+[%]*),[ ]*([+-]*[\d]+[%]*)\)/g;
        var computedVal = val.replace(reg, function (match, x, y) { return "translate(".concat(getTranslate(node_1, x, y), ")"); });
        node_1.attr('transform', computedVal);
    }
    catch (e) {
        // do nothing
    }
}
//# sourceMappingURL=transform.js.map